import React from 'react';
import { useI18n } from '../i18n/index.jsx';

// add-to-calendar-button ships its own translations for these languages;
// anything else falls back to the component's English default. (SB-8809)
const ATCB_LANGUAGES = new Set(['en', 'de', 'fr', 'es', 'pt', 'it', 'nl', 'pl', 'tr', 'sv', 'fi', 'cs', 'ja', 'zh', 'ko', 'vi', 'ar', 'hi']);

const DEFAULT_OPTIONS = "'Apple', 'Google', 'iCal', 'Outlook.com', 'Yahoo', 'MicrosoftTeams', 'Microsoft365'";
const LIGHT_STYLES = "--btn-text: #343434; --font: 'proxima-nova', sans-serif;";
const DARK_STYLES = "--font: 'proxima-nova', sans-serif;";

const AddToCalendar = ({
  sessionData = {},
  isDarkTheme,
  options = DEFAULT_OPTIONS,
  showLabelButton = true,
  enabled = true,
  isLoading = false,
}) => {
  const {
    title,
    description,
    startsAtAddEvent: startsAtDate,
    startTimeAddEvent: startAtTime,
    endsAtAddEvent: endsAt,
    endTimeAddEvent: endTime,
    timezone,
  } = sessionData || {};
  const lightMode = isDarkTheme ? 'dark' : 'light';
  const { t, locale } = useI18n();
  const atcbLanguage = locale ? locale.split('_')[0].toLowerCase() : null;

  if (!enabled) {
    return null;
  }

  if (isLoading) {
    return <div className="add-to-calendar-loading">{t('loading_data')}</div>;
  }

  return (
    <div className="add-to-calendar-button-container">
      <add-to-calendar-button
        name={title}
        description={description}
        options={options}
        startDate={startsAtDate}
        startTime={startAtTime}
        endDate={endsAt}
        endTime={endTime}
        timeZone={timezone}
        {...(atcbLanguage && ATCB_LANGUAGES.has(atcbLanguage) ? { language: atcbLanguage } : {})}
        hideBackground
        size={4}
        hideCheckmark={true}
        lightMode={lightMode}
        styleLight={LIGHT_STYLES}
        styleDark={DARK_STYLES}
        {...(showLabelButton ? {} : { hideTextLabelButton: true, hideTextLabelList: true })}
      ></add-to-calendar-button>
    </div>
  );
};

export default AddToCalendar;
